import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { ERROR_EMUNS, LOADING_EMUNS } from "../constant";
import { CreateCard } from "../../Card";
import * as a from "../action";

const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 2rem;
  margin: 1rem 0px;
`;

const Form = styled.div`
  flex: 1 1 0%;
  margin: 1rem 0px;
`;

const UploadSpreadSheetErrors = () => {
  const dispatch = useDispatch();
  const loadingState = useSelector((state) => state.ssUploader.loading.state);
  const errorCards = useSelector((state) => state.ssUploader.cards.errors);

  useEffect(() => {
    if (errorCards.length === 0) {
      dispatch(a.doResetCards());
      dispatch(a.setLoadingState(LOADING_EMUNS.DEFAULT));
      dispatch(a.setErrorType(ERROR_EMUNS.DEFAULT));
    }
  }, [errorCards]);

  const removeCard = (idx) => {
    dispatch(a.doRemoveErrorCard(idx));
  };

  if (loadingState === LOADING_EMUNS.ERROR) {
    const cardToDisplay = [];

    errorCards?.forEach((card, i) => {
      cardToDisplay.push(
        <Form key={card.idx}>
          <CreateCard
            idx={card.idx}
            enteredCard={card}
            canRemove={true}
            doRemove={() => {
              removeCard(card.idx);
            }}
            isEditCard={true}
          />
        </Form>
      );
    });

    return <InputBox>{cardToDisplay}</InputBox>;
  }

  return null;
};

export { UploadSpreadSheetErrors };
